export const QUOTE = "32e32fe3-4689-11e9-82f6-0242ac120002";
export const REJECTED_QUOTE = "398abe00-4689-11e9-82f6-0242ac120002";
export const PASSED_QUOTE = "41eb3b82-4689-11e9-82f6-0242ac120002";
export const CLOSED_LOAN = "49f49d06-4689-11e9-82f6-0242ac120002";
export const PAID_OFF = "51df0692-4689-11e9-82f6-0242ac120002";
export const WINNING_QUOTE = "d22a1730-6cf7-11e9-bf8d-0242ac140002";
export const IN_CLOSING = "a9231164-3d37-11ea-b5bd-00ff12c3b408";
export const MODIFYING = "c2394726-ef37-4d2d-8d4d-a3364ade7dc6";

export const loanStatusList = [
  { name: "Quote", value: QUOTE },
  { name: "Rejected", value: REJECTED_QUOTE },
  { name: "Passed", value: PASSED_QUOTE },
  { name: "Closed", value: CLOSED_LOAN },
  { name: "Paid Off", value: PAID_OFF },
  { name: "Winning Quote", value: WINNING_QUOTE },
  { name: "In Closing", value: IN_CLOSING },
  { name: "Modifying", value: MODIFYING }
];

export default {
  QUOTE,
  REJECTED_QUOTE,
  PASSED_QUOTE,
  CLOSED_LOAN,
  PAID_OFF,
  WINNING_QUOTE,
  IN_CLOSING,
  MODIFYING
};
